/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'Vlt-icon-minus': {
    width: 16,
    height: 16,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M2.351 11c-.47 0-.851.336-.851.75s.381.75.851.75H21.65c.47 0 .851-.336.851-.75s-.381-.75-.851-.75H2.35z"/>'
  }
})
